import * as React from "react";
import type { SVGProps } from "react";
const SvgChartBreakoutSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M10.338 4.022h-5.67A2.27 2.27 0 0 0 2.4 6.29v13.608a2.27 2.27 0 0 0 2.268 2.268h13.608a2.27 2.27 0 0 0 2.267-2.268v-6.804m-17.576.066c4.536 0 10.773.567 11.34-3.402m0 0h-3.402m3.402 0v4.076m-.078-12v2.447M21.6 9.205h-2.447m.18-5.103-1.624 1.621"
    />
  </svg>
);
export default SvgChartBreakoutSquare;
